import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

// import { CheckTrackComponent } from "./check-track/check-track.component";
// import { LostPackagesComponent } from "./lost-packages/lost-packages.component";
// import { AuthGuard } from "./auth-guard.service";
import { InfoPageComponent } from './info-page/info-page.component';

const appRoutes: Routes = [
    { path: '', component: InfoPageComponent },
    // { path: 'check', component: CheckTrackComponent, canActivate: [AuthGuard], data: { userRole: ['customer', 'storage'] } }, 
    // { path: 'lost', component: LostPackagesComponent },
    // {path: '', redirectTo: '/check', pathMatch: 'full'},
    // {path: '**', redirectTo: '/check', pathMatch: 'full'}
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, { useHash: true })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {

}
